<template>
  <div>
    <modal-tarjetas
      :listTarjetas="listTarjetas"
      :institucion="institucionSeleccionada"
    ></modal-tarjetas>
    <content-detalle-general
      :listDetalle="listDetalle"
      :listFijos="listValoreFijos"
      :hasRecibo="hasRecibo"
      :isReciboPagado="isReciboPagada"
      :loading="showLoadingRecibo"
      :totalRecibo="totalRecibo"
      :totalFijo="totalFijos"
      :dataReciboCabecera="dataReciboCabecera"
    ></content-detalle-general>
    <dividir-pago
      :multa="multaSeleccionada"
      @detalle="crearLista($event)"
      @recargaMultas="recargarMulta"
      @showRecibo="getDetalleRecibo($event, true)"
    ></dividir-pago>
    <add-multa-global
      :campeonato="campeonatoSeleccionado"
      :listCategoriasAdmin="listCategoriasAdmin"
      @multaGlobalCreada="refrescarMultas"
    ></add-multa-global>
    <b-row>
      <b-col md="3">
        <b-card no-body class="p-1">
          <b-row>
            <b-col
              md="12"
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA
              "
            >
              <v-select
                :options="listCampeonatos"
                placeholder="Sel. Camp"
                :clearable="false"
                v-model="campeonatoSeleccionado"
              />
            </b-col>
            <b-col md="12" style="margin-top:5px" class="mb-1">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input placeholder="Buscar" v-model="search" />
              </b-input-group>
            </b-col>
            <b-col
              class="d-flex justify-content-center"
              md="3"
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA
              "
            >
              <b-button
                v-b-tooltip.hover.v-primary
                title="Crear Multa Global"
                variant="flat-primary"
                class="btn-icon"
                @click="showModalGlobal"
                size="sm"
              >
                <feather-icon size="22" icon="GlobeIcon" />
              </b-button>
            </b-col>
            <b-col
              class="d-flex justify-content-center"
              md="3"
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA
              "
            >
              <b-button
                v-b-tooltip.hover.v-primary
                variant="flat-primary"
                class="btn-icon"
                title="Excel todos los valores"
                size="sm"
                @click="imprimirMultasTodas"
              >
                <feather-icon size="22" icon="PrinterIcon" />
              </b-button>
            </b-col>
          </b-row>

          <b-overlay
            :show="showLoadingIns"
            rounded="sm"
            :class="[showLoadingIns ? 'mt-5' : 'mt-0', '']"
          >
            <!-- <b-badge variant="danger" class="mr-1">
              Pendiente
            </b-badge>
            <b-badge variant="success" style="margin-bottom:3px">
              Pagado
            </b-badge> -->
            <div style="height:63vh; overflow:scroll">
              <b-list-group>
                <b-list-group-item
                  button
                  v-for="item in listInstitucionesFilter"
                  :key="item.id"
                  @click="getEquipos(item)"
                  ><img
                    width="25"
                    :src="item.foto"
                    alt=""
                    @click="updateInstitucion(item)"
                  />
                  <span
                    class="ml-1"
                    style="text-transform: capitalize; font-size:12px;"
                    ><b>{{ item.nombre }}</b></span
                  >
                  <br />
                  <b-row class="mt-1">
                    <b-col md="6">
                      <b-badge
                        style="float:right;width:80%"
                        :variant="item.debe != '0.00' ? 'danger' : ''"
                        class="ml-1"
                      >
                        {{ item.debe }}
                      </b-badge>
                    </b-col>
                    <b-col md="6">
                      <b-badge style="float:right;width:80%" variant="success">
                        {{ item.pagado }}
                      </b-badge>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-overlay>
        </b-card>
      </b-col>
      <b-col md="9">
        <span class="d-none">{{ limpiaRef }}</span>
        <b-card no-body style="padding:10px 10px 0px 10px">
          <b-overlay
            v-if="institucionSeleccionada.nombre != null"
            :show="showLoadingEquipos"
            rounded="sm"
          >
            <b-row>
              <b-col md="3" class="p-0">
                <img
                  :src="institucionSeleccionada.foto"
                  alt="nd"
                  width="40"
                  style="margin-left:10px"
                />
                <b
                  class="ml-1"
                  style="text-transform: capitalize; font-size:10px"
                  >{{ institucionSeleccionada.nombre }}</b
                ></b-col
              >
              <b-col md="5">
                <v-select
                  placeholder="Seleccione Equipo"
                  :options="listEquipos"
                  :clearable="false"
                  style="width: 100%"
                  v-model="equipoSeleccionado"
                  @input="
                    getMultaEquipo(
                      equipoSeleccionado.value,
                      campeonatoSeleccionado.value,
                    )
                  "
                />
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <flat-pickr
                    placeholder="Filtrar x fecha"
                    class="form-control"
                    v-model="rangeDate"
                    :config="{ mode: 'range' }"
                    @on-change="filterTable"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
        <b-card no-body class="card-aux" style="padding:0px 10px 0px 10px">
          <template v-if="equipoSeleccionado.value != ''">
            <b-row class="mt-1">
              <b-col
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TESORERIA
                "
                md="12"
                class="border-right pr-4"
                ><add-multa-only
                  :dataPartido="partidoAux"
                  :idEquipo="equipoSeleccionado.value"
                  :campeonato="campeonatoSeleccionado"
                  @multaInsertada="multaInsertada($event)"
                ></add-multa-only
              ></b-col>
            </b-row>
            <b-overlay :show="showLoadingTable">
              <b-row style="margin-top:16px">
                <b-table
                  ref="refInvoiceListTable"
                  :fields="tableColumns"
                  :items="listMultasFilter"
                  primary-key="id_usuario"
                  show-empty
                  responsive
                  empty-text="No se encontraron datos"
                  class="position-relative ml-1 mr-1"
                  style="max-height:50vh; "
                  :sticky-header="true"
                  :no-border-collapse="true"
                  small
                >
                  <template #cell(cantidad)="data">
                    <div style="text-align:center">
                      <span>{{ data.item.cantidad }}</span>
                    </div>
                  </template>
                  <template #cell(concepto)="data">
                    <div>
                      <span
                        @click="openPartido(data.item)"
                        :style="
                          data.item.is_tarjeta == 's'
                            ? 'font-size:12px;text-decoration:underline;cursor:pointer'
                            : 'font-size:12px;'
                        "
                        >{{ data.item.concepto }}</span
                      >
                      <br />
                      <span style="font-size:10px;color:gray">{{
                        data.item.fecha.substring(0, 10)
                      }}</span>
                    </div>
                  </template>

                  <template #cell(v_unitario)="data">
                    <div style="text-align:right;font-size:13px">
                      {{ data.item.v_unitario }}
                    </div>
                  </template>
                  <template #cell(v_total)="data">
                    <div style="text-align:right;font-size:13px">
                      {{ data.item.v_total }}
                    </div>
                  </template>
                  <template #cell(pagado)="data">
                    <div
                      v-if="data.item.valor_cancelado != 0"
                      style="color: #44a720;font-weight: bold;font-size: 14px; text-align:right"
                    >
                      <!-- <b-badge
                        v-if="data.item.valor_cancelado != 0"
                        :variant="'success'"
                        style="width:70%;text-align:right"
                      > -->
                      {{ data.item.valor_cancelado }}
                      <!-- </b-badge> -->
                    </div>
                  </template>
                  <template #cell(saldo)="data">
                    <div
                      v-if="data.item.valor_pendiente != 0"
                      style="color: #de2a2a;font-weight: bold;font-size: 14px; text-align:right"
                    >
                      <!-- <b-badge
                        v-if="data.item.valor_pendiente != 0"
                        :variant="'danger'"
                        style="width:70%;text-align:right"
                      > -->
                      {{ data.item.valor_pendiente }}
                      <!-- </b-badge> -->
                    </div>
                  </template>
                  <template #cell(acciones)="data">
                    <div class="text-nowrap" style="float:right">
                      <feather-icon
                        :id="`invoice-row-${data.item.id}-send-icon`"
                        icon="EditIcon"
                        class="cursor-pointer"
                        size="12"
                        @click="showModalDividir(data.item)"
                      />
                      <feather-icon
                        v-if="!data.item.conDetalle"
                        :id="`multa-${data.item.id_multa}`"
                        icon="FileTextIcon"
                        class="ml-1 cursor-pointer"
                        size="12"
                        @click="getDetalleRecibo(data.item, false)"
                      ></feather-icon>
                      <feather-icon
                        v-if="
                          USER().rol === ROLES.SUPER ||
                            USER().rol === ROLES.ADMIN ||
                            USER().rol === ROLES.TESORERIA
                        "
                        :id="`invoice-row-${data.item.id}-preview-icon`"
                        icon="Trash2Icon"
                        size="12"
                        class="ml-1 cursor-pointer"
                        @click="
                          deleteMulta(
                            data.item.id_multa,
                            data.item.bloquear,
                            data.item.cancelado,
                            data.item.tiene_detalles_bloqueados,
                            data.item.v_total,
                          )
                        "
                      />
                    </div>
                  </template>
                  <template #custom-foot>
                    <tr style="position: sticky; bottom: 0;  z-index: 10;  ">
                      <th style="background-color:#f6f3c0 ">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          @click="imprimirMultas"
                          style="height:25px; font-size:10px"
                          size="sm"
                        >
                          Imprimir
                        </b-button>
                      </th>
                      <th style="background-color:#f6f3c0 ">
                        <vue-excel-xlsx
                          :data="listMultasExcel"
                          :columns="columnsExcel"
                          :file-name="'listado'"
                          :file-type="'xlsx'"
                          :sheet-name="'reporte'"
                          class="excel"
                        >
                          Exportar Excel
                        </vue-excel-xlsx>
                      </th>
                      <th
                        colspan="1"
                        class="text-right"
                        style="background-color:#f6f3c0 "
                      >
                        <strong>Totales:</strong>
                      </th>
                      <th
                        style="text-align:right;font-size:13px;background-color:#f6f3c0"
                      >
                        {{ totalVUnitario }}
                      </th>
                      <th
                        style="text-align:right ;font-size:13px;background-color:#f6f3c0"
                      >
                        {{ totalVTotal }}
                      </th>
                      <th
                        style="text-align:right ;font-size:13px;color: #44a720;background-color:#f6f3c0"
                      >
                        {{ valorPagado }}
                      </th>
                      <th
                        style="text-align:right ;font-size:13px;color: #de2a2a;background-color:#f6f3c0"
                      >
                        {{ valorPendiente }}
                      </th>

                      <th style="background-color:#f6f3c0"></th>
                    </tr>
                  </template>
                </b-table>
              </b-row>
              <!-- <div
                class="footer-fijo"
                style="
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        border-top: 1px solid #dee2e6;
        box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
        padding: 8px 16px;
        text-align: right;
      "
              >
                <table >
                  <tr>
                    <td class="text-right">
                      <strong>Totales:</strong>
                    </td>
                     <td class="text-right">
                      <strong>Totales:</strong>
                    </td>
                    <td style="text-align:right">{{ totalVUnitario }}</td>
                    <td style="text-align:right">{{ totalVTotal }}</td>
                    <td style="text-align:right">{{ valorPagado }}</td>
                    <td style="text-align:right">{{ valorPendiente }}</td>
                    <td style="text-align:right">ss</td>
                  </tr>
                </table>
              </div> -->
            </b-overlay>
          </template>
          <hr />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BButton,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  //   BFormCheckbox,
  VBTooltip,
  BInputGroupPrepend,
  BInputGroup,
  BOverlay,
  BBadge,
  BFormInput,
  BTable,
  VBPopover,
  // BPopover,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import * as XLSX from 'xlsx'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  URL_CARNET,
  // vvvv
} from '../../utils/variables'
import addMultaOnly from './AddMultaOnly.vue'
import DividirPago from './DividirPago.vue'
import AddMultaGlobal from './AddMultaGlobal.vue'
// import ItemDetalleRecibo from './itemDetalleRecibo.vue'
import ModalTarjetas from './ModalPartido.vue'
import ContentDetalleGeneral from './ContentDetalleGeneral.vue'

export default {
  components: {
    ModalTarjetas,
    BCard,
    BButton,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    // BFormCheckbox,
    BInputGroupPrepend,
    BInputGroup,
    BOverlay,
    BBadge,
    vSelect,
    BFormInput,
    addMultaOnly,
    BTable,
    flatPickr,
    DividirPago,
    AddMultaGlobal,
    // BPopover,
    // ItemDetalleRecibo,
    ContentDetalleGeneral,
    // ToastificationContent,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-popover': VBPopover,
  },
  props: {
    listInstituciones: Array,
    showLoadingIns: Boolean,
    limpiarDerecha: Boolean,
    listCampeonatos: Array,
    seleccionado: Object,
  },
  setup(props, { emit }) {
    const search = ref('')
    const showLoadingEquipos = ref(false)
    const showLoadingDetalle = ref(false)
    const showLoadingRecibo = ref(false)
    const listEquipos = ref([])
    const listMultas = ref([])
    const listCategoriasAdmin = ref([])
    const rangeDate = ref(null)
    const fechaUsar = ref('')
    const popoverShowIA = ref([])
    const listDetalleRecibo = ref([])
    const listTarjetas = ref([])
    const listValoreFijos = ref([])
    const listDetalle = ref([])
    const hasRecibo = ref(false)
    const isReciboPagada = ref(false)

    const showLoadingTable = ref(false)
    const multaSeleccionada = ref({ detalle: [] })
    const dataReciboCabecera = ref({ fecha: '' })
    const institucionSeleccionada = ref({ foto: '', apodo: null })
    // const institucionSeleccionadaAux = ref({ foto: '', apodo: null })
    const { getApi, postApi } = apiCall()
    const partidoAux = { id_partido: null }
    const equipoSeleccionado = ref({ label: 'Seleccione Equipo', value: '' })
    const tableColumns = [
      // { key: 'nombre', sortable: true },
      // { key: 'apellido', sortable: true },
      { key: 'cantidad', sortable: true, label: 'Cant' },
      { key: 'concepto', sortable: true },
      { key: 'v_unitario', sortable: true, label: 'V.U' },
      { key: 'v_total', sortable: true, label: 'V.T' },
      { key: 'pagado', sortable: true, label: 'Abono' },
      { key: 'saldo', sortable: true, label: 'Saldo' },
      { key: 'acciones', label: 'acc' },
    ]
    const columnsExcel = ref([
      {
        label: 'Discplina',
        field: 'disciplina',
      },
      {
        label: 'Categoria',
        field: 'categoria',
      },
      {
        label: 'Equipo',
        field: 'equipo',
      },
      {
        label: 'F/Ingreso',
        field: 'fecha',
      },
      {
        label: 'Cantidad',
        field: 'cantidad',
      },
      {
        label: 'Detalle',
        field: 'concepto',
      },
      {
        label: 'V.Unitario',
        field: 'v_unitario',
      },
      {
        label: 'V.Total',
        field: 'v_total',
      },
      {
        label: 'V.Submulta',
        field: 'valor_total_detalle',
      },
      {
        label: 'Abono',
        field: 'valor_cancelado',
      },
      {
        label: 'Saldo',
        field: 'valor_pendiente',
      },
      {
        label: 'id_recibo',
        field: 'id_recibo',
      },
      {
        label: 'f/generacion',
        field: 'fecha_genera',
      },
      {
        label: 'f/pago',
        field: 'fecha_pago',
      },
    ])

    const campeonatoSeleccionado = computed({
      get: () => props.seleccionado,
      set: value => {
        // props.isManualProp = value
        emit('change', value)
      },
    })
    function refrescarMultas() {
      emit('recargaInstitucions')
    }
    function ocultarPopover(idMulta) {
      this.popoverShowIA[idMulta] = false
    }
    async function getListCategoriasAdmin(idTorneo) {
      listCategoriasAdmin.value = []
      const path = `ApiConfiguration/getCategoriasEquipos/${idTorneo}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        data.data.forEach(element => {
          const obj = {
            label: `${element.disciplina} ${element.categoria}`,
            value: element.id_categoria,
            equipos: element.equipos,
            id_disciplina: element.id_disciplina,
            tieneClasificado: element.tieneClasificado,
          }
          listCategoriasAdmin.value.push(obj)
        })
      } else {
        listCategoriasAdmin.value = []
      }
    }
    const limpiaRef = computed(
      // eslint-disable-next-line
      () => {
        // console.log(props.limpiarDerecha)
        if (props.limpiarDerecha) {
          institucionSeleccionada.value = { foto: '', apodo: null }
          equipoSeleccionado.value = { label: 'Seleccione Equipo', value: '' }
          // listCategoriasUsadasNoUsadas.value = []
        }
        // eslint-disable-next-line
        // return props.limpiarDerecha
        // eslint-disable-next-line
      },
    )
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    watch(cambioTorneo, data => {
      emit('changeTorneo', data)
    })
    const listInstitucionesFilter = computed(
      () =>
        // eslint-disable-next-line
        props.listInstituciones.filter(
          player =>
            // eslint-disable-next-line
            player.nombre.toLowerCase().includes(search.value.toLowerCase()),
          // eslint-disable-next-line
        ),
      // eslint-disable-next-line
    )

    async function getDetalleRecibo(item, isDividir) {
      // listDetalleRecibo.value = []
      // console.log(item)
      // console.log(isDividir)
      let idEnviar = item.id_multa
      if (isDividir) {
        idEnviar = item.id_dividir_multa
      }

      store.commit('someVariables/UPDATE_SHOW_MODAL_DETALLE_RECIBO', true)
      showLoadingRecibo.value = true
      listDetalle.value = []
      listValoreFijos.value = []
      hasRecibo.value = false
      const path = `ApiMultas/getMultaInRecibo/${idEnviar}/${isDividir}`
      const data = await getApi(URL, path)
      // console.log(data)
      if (data != null) {
        listDetalle.value = data.detalle_recibo
        hasRecibo.value = data.hasRecibo
        listValoreFijos.value = data.valoresFijos
        isReciboPagada.value = data.isReciboPagado
        dataReciboCabecera.value = data.recibo
      }

      showLoadingRecibo.value = false
      // listDetalleRecibo.value = data.data
      // showLoadingDetalle.value = false
    }
    const totalRecibo = computed(() => {
      let total = 0
      listDetalle.value.forEach(element => {
        total += Number(element.v_total)
      })
      return total.toFixed(2)
    })
    const totalFijos = computed(() => {
      let total = 0
      listValoreFijos.value.forEach(element => {
        total += Number(element.valor)
      })
      // console.log(total)
      return total.toFixed(2)
    })
    // const totalPagarPartido = computed(
    //   // eslint-disable-next-line
    //   () =>
    //     // eslint-disable-next-line
    //     (Number(totalRecibo.value) + Number(totalFijos))
    //       // eslint-disable-next-line
    //       .toFixed(2)
    // )
    async function getTarjetasPartido(item) {
      listTarjetas.value = []
      const path = `ApiSanciones/getSancionesIdPartidoParaTarjetas/${item.id_partido}`
      const data = await getApi(URL, path)
      // console.log(data.data)
      // console.log(item)
      listTarjetas.value = data.data.filter(
        // eslint-disable-next-line
        element => element.idEquipo === item.id_equipo,
      )
    }
    function openPartido(item) {
      if (item.is_tarjeta === 's') {
        getTarjetasPartido(item)
        store.commit('someVariables/UPDATE_SHOW_PARTIDO_TESORERIA', true)
      }
    }
    function openRecibo() {
      store.commit('someVariables/UPDATE_SHOW_MODAL_DETALLE_RECIBO', true)
    }
    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[0].trim(),
          }
        }
      }
      if (rangeDate.value === '') {
        auxiliar = {
          valido: false,
          inicio: null,
          fin: null,
        }
      }
      return auxiliar
    }
    const listMultasFilter = computed(() => {
      const fecha = separaFecha()
      let listReturn = listMultas.value
      if (fecha != null) {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listMultas.value.filter(
            multa =>
              // eslint-disable-next-line
              multa.onlyFecha <= fecha.fin && multa.onlyFecha >= fecha.inicio,
            // eslint-disable-next-line
          )
        } else {
          listReturn = listMultas.value
        }
      }
      return listReturn
      // listMultas.value
      // eslint-disable-next-line
    })
    // function formatNumberComma(value) {
    //   if (value == null) return ''
    //   return Number(value)
    //     .toFixed(2)
    //     .replace('.', ',')
    // }
    const listMultasExcel = computed(() => {
      const rows = []

      listMultasFilter.value.forEach(item => {
        // --- Fila principal ---
        rows.push({
          disciplina: item.disciplina ?? '',
          categoria: item.categoria ?? '',
          equipo: item.equipo ?? '',
          fecha: item.onlyFecha ?? '',
          cantidad: item.cantidad ?? '',
          concepto: item.concepto ?? '',
          v_unitario: Number(item.v_unitario),
          v_total: Number(item.v_total),
          valor_cancelado: Number(item.valor_cancelado),
          valor_pendiente: Number(item.valor_pendiente),
          id_recibo: item.recibo_multa?.id_recibo || null,
          fecha_genera: item.recibo_multa?.fecha || null,
          fecha_pago: item.recibo_multa?.fecha_pago || null,
        })

        // --- Si tiene detalles: agregar filas debajo ---
        if (Array.isArray(item.detalle) && item.detalle.length > 0) {
          item.detalle.forEach(d => {
            rows.push({
              disciplina: item.disciplina ?? '',
              categoria: item.categoria ?? '',
              equipo: item.equipo ?? '',
              fecha: item.onlyFecha ?? '',
              cantidad: d.cantidad ?? '',
              concepto: d.concepto ?? '',
              // v_unitario: Number(-d.v_unitario),
              // v_total: Number(-d.v_total),
              // valor_cancelado: Number(-d.valor_cancelado),
              // valor_pendiente: Number(d.valor_pendiente),
              valor_total_detalle: Number(d.v_total),
              id_recibo: d.recibo_multa?.id_recibo || null,
              fecha_genera: d.recibo_multa?.fecha || null,
              fecha_pago: d.recibo_multa?.fecha_pago || null,
            })
          })
        }
      })

      return rows
    })

    // const columns = computed(() => {
    //   if (!listMultasFilter.value || listMultasFilter.value.length === 0) {
    //     return []
    //   }
    //   const keys = Object.keys(listMultasFilter.value[0])

    //   return keys.map(k => ({
    //     label: k.toUpperCase(),
    //     field: k,
    //   }))
    // })
    async function imprimirMultas() {
      // console.log(equipoSeleccionado.value)
      const data = {
        multas: listMultasFilter.value,
        equipo: `${institucionSeleccionada.value.nombre} ${equipoSeleccionado.value.label}`,
      }
      const path = 'ApiMultas/printMultas'
      await postApi(URL, path, data)
      window.open(
        `${URL_CARNET}multas.pdf?v=${Math.random() * 100}`,
        // eslint-disable-next-line
        '_blank',
      )
    }
    const valorPagado = computed(() => {
      let total = 0
      listMultasFilter.value.forEach(element => {
        total += Number.parseFloat(element.valor_cancelado)
      })
      return total.toFixed(2)
    })
    const valorPendiente = computed(() => {
      let total = 0
      listMultasFilter.value.forEach(element => {
        total += Number.parseFloat(element.valor_pendiente)
      })
      return total.toFixed(2)
    })
    function filterTable() {
      fechaUsar.value = separaFecha()
    }
    function doListSelect(data) {
      const listReturn = []
      data.forEach(element => {
        let obj = {
          label: `${element.disciplina} ${element.categoria}`,
          value: element.id_equipo,
        }
        if (element.alias_equipo !== '') {
          obj = {
            label: `${element.disciplina} ${element.categoria} - ${element.alias_equipo}`,
            value: element.id_equipo,
          }
        }
        listReturn.push(obj)
      })
      return listReturn
    }

    async function getEquipos(item) {
      // listCategoriasUsadasNoUsadas.value = []
      showLoadingEquipos.value = true
      equipoSeleccionado.value = { label: 'Seleccione Equipo', value: '' }
      emit('limpiaDerecha', false)
      const path = `ApiConfiguration/getEquipos/${item.id_institucion}`
      const data = await getApi(URL, path)
      listEquipos.value = doListSelect(data.data)
      institucionSeleccionada.value = item
      // institucionSeleccionadaAux.value = { ...item }

      showLoadingEquipos.value = false
    }

    async function getMultaEquipo(id, idCampeonato) {
      // partidoSeleccionado.value = item
      // console.log(idCampeonato)
      showLoadingTable.value = true
      listMultas.value = []
      const path = `ApiMultas/getMultaEquipoTodas/${id}/${idCampeonato}`
      const data = await getApi(URL, path)
      listMultas.value = data.data
      showLoadingTable.value = false
    }
    function recargarMulta() {
      getMultaEquipo(
        equipoSeleccionado.value.value,
        // eslint-disable-next-line
        campeonatoSeleccionado.value.value,
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'GUARDADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
      store.commit('someVariables/UPDATE_SHOW_DIVIDIR_MULTA', false)
    }
    function showModalGlobal() {
      store.commit('someVariables/UPDATE_SHOW_MULTA_GLOBAL', true)
      getListCategoriasAdmin(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
    }
    async function imprimirMultasTodas() {
      const path = `ApiMultas/getMultasTodasXls/${campeonatoSeleccionado.value.value}`
      const data = await getApi(URL, path)
      const rows = []
      // console.log(data.data)

      data.data.forEach(item => {
        // --- Fila principal ---
        rows.push({
          disciplina: item.disciplina ?? '',
          categoria: item.categoria ?? '',
          equipo: item.equipo ?? '',
          fecha: item.onlyFecha ?? '',
          cantidad: item.cantidad ?? '',
          concepto: item.concepto ?? '',
          v_unitario: Number(item.v_unitario),
          v_total: Number(item.v_total),
          valor_cancelado: Number(item.valor_cancelado),
          valor_pendiente: Number(item.valor_pendiente),
          id_recibo: item.recibo_multa?.id_recibo || null,
          fecha_genera: item.recibo_multa?.fecha || null,
          fecha_pago: item.recibo_multa?.fecha_pago || null,
        })

        // --- Si tiene detalles: agregar filas debajo ---
        if (Array.isArray(item.detalle) && item.detalle.length > 0) {
          item.detalle.forEach(d => {
            rows.push({
              disciplina: item.disciplina ?? '',
              categoria: item.categoria ?? '',
              equipo: item.equipo ?? '',
              fecha: item.onlyFecha ?? '',
              cantidad: d.cantidad ?? '',
              concepto: d.concepto ?? '',
              // v_unitario: formatNumberComma(d.v_unitario),
              // v_total: Number(d.v_total),
              // valor_cancelado: Number(d.valor_cancelado),
              // valor_pendiente: Number(d.valor_pendiente),
              valor_total_detalle: Number(d.v_total),
              id_recibo: d.recibo_multa?.id_recibo || null,
              fecha_genera: d.recibo_multa?.fecha || null,
              fecha_pago: d.recibo_multa?.fecha_pago || null,
            })
          })
        }
      })
      const exportRows = rows.map(row => {
        const newRow = {}
        columnsExcel.value.forEach(col => {
          newRow[col.label] = row[col.field] ?? ''
        })
        return newRow
      })
      const ws = XLSX.utils.json_to_sheet(exportRows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Multas')
      XLSX.writeFile(wb, 'multas.xlsx')
    }

    function multaInsertada(item) {
      // console.log(item.v_total)
      showLoadingTable.value = true
      listMultas.value.unshift(item)
      institucionSeleccionada.value.debe =
        Number(institucionSeleccionada.value.debe) + Number(item.v_total)
      // props.listInstituciones[0].debe = ˝909
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'GUARDADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
      showLoadingTable.value = false
    }
    function showModalDividir(item) {
      multaSeleccionada.value = { ...item }
      store.commit('someVariables/UPDATE_SHOW_DIVIDIR_MULTA', true)
    }
    const totalVUnitario = computed(
      () =>
        // eslint-disable-next-line
        listMultasFilter.value
          .reduce((sum, item) => sum + parseFloat(item.v_unitario || 0), 0)
          // eslint-disable-next-line
          .toFixed(2),
      // eslint-disable-next-line
    )
    const totalVTotal = computed(
      () =>
        // eslint-disable-next-line
        listMultasFilter.value
          .reduce((sum, item) => sum + parseFloat(item.v_total || 0), 0)
          // eslint-disable-next-line
          .toFixed(2),
      // eslint-disable-next-line
    )
    async function deleteMulta(
      idMulta,
      bloquearDato,
      isCancelado,
      tieneDetalleBloqueado,
      // eslint-disable-next-line
      valorTotal,
    ) {
      showLoadingTable.value = true
      const data = {
        id_multa: idMulta,
        rol: USER().rol,
        bloquear: bloquearDato,
        cancelado: isCancelado,
        hayDetalleBloqueado: tieneDetalleBloqueado,
      }
      const path = 'ApiMultas/deleteMulta'
      const response = await postApi(URL, path, data)
      // console.log(response)
      if (response !== null) {
        if (response.flag === 'si') {
          institucionSeleccionada.value.debe -= valorTotal
          const found = listMultas.value.findIndex(
            // eslint-disable-next-line
            element => element.id_multa === data.id_multa,
          )
          listMultas.value.splice(found, 1)
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'ELIMINADO con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            },
          )
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title:
                  'La multa esta asociada a multiple información, acción no permitida',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            },
          )
        }
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title:
                'La multa esta asociada a multiple información, acción no permitida',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
      }
      showLoadingTable.value = false
    }

    return {
      search,
      URL,
      USER,
      ROLES,
      listInstitucionesFilter,
      showLoadingEquipos,
      institucionSeleccionada,
      getEquipos,
      listEquipos,
      partidoAux,
      equipoSeleccionado,
      getMultaEquipo,
      tableColumns,
      listMultas,
      multaInsertada,
      rangeDate,
      showModalDividir,
      multaSeleccionada,
      deleteMulta,
      limpiaRef,
      showLoadingTable,
      filterTable,
      listMultasFilter,
      valorPagado,
      valorPendiente,
      recargarMulta,
      showModalGlobal,
      refrescarMultas,
      imprimirMultas,
      campeonatoSeleccionado,
      getListCategoriasAdmin,
      listCategoriasAdmin,
      popoverShowIA,
      ocultarPopover,
      getDetalleRecibo,
      listDetalleRecibo,
      showLoadingDetalle,
      openPartido,
      listTarjetas,
      openRecibo,
      listDetalle,
      listValoreFijos,
      hasRecibo,
      isReciboPagada,
      totalRecibo,
      totalFijos,
      showLoadingRecibo,
      totalVUnitario,
      totalVTotal,
      dataReciboCabecera,
      columnsExcel,
      listMultasExcel,
      imprimirMultasTodas,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.card-aux {
  margin-top: -15px;
}
.sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: #f8f9fa; /* Fondo para diferenciar */
  z-index: 2; /* Para que no se superponga al contenido */
  font-weight: bold;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1); /* Añade un sombreado */
}
.excel {
  color: #ede5e5;
  background-color: #243e3e;
  border: 4px;
  border-radius: 4px;
  font-size: 11px;
  padding: 2px 4px 2px 5px;
  margin-right: 12px;
  font-weight: bold;
  height: 23px;
}
</style>
